





































import { Component } from 'vue-property-decorator';
import MinCard from './min-card.vue';
import ChartLine from './chart-line.vue';
import CronjobServices from '@/services/cronjob';
import DatajobServices from '@/services/datajob';
import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
@Component({
  components: { MinCard, ChartLine }
})
export default class All extends mixins(DictMixin) {
  bread = [{ name: '作业调度管理' }, { name: '作业调度总览' }];
  jobSrv = new CronjobServices();
  datajobSrv = new DatajobServices();
  items: string[] = [];

  created() {
    this.getList();
    this.getRate();
  }

  showCard: any[] = [];
  async getList() {
    let list = await this.jobSrv.getTotal();
    let datalist = await this.datajobSrv.getTotal();
    list = list.concat(datalist);

    this.showCard = list.map((v: any) => {
      let status = 1;
      if (v.total1 + v.total2 === 0) status = 1;
      if (v.total == v.total2) status = 2;
      if (v.total == v.total1) status = 3;
      if (v.total !== v.total2 && v.total2 > 0) status = 4;
      if (v.total !== v.total1 && v.total1 > 0) status = 5;
      return {
        title: v.job_group_name,
        number: v.total,
        ratio: v.rate,
        status: status,
        active: true
      };
    });
  }

  lineData: any[] = [];
  shownLineData: any[] = [];
  async getRate() {
    if (!this.DICT_SCHEDULE_JOB_GROUP) {
      setTimeout(() => this.getRate(), 100);
      return false;
    }
    let list = await this.jobSrv.getRecordRate();
    let datalist = await this.datajobSrv.getRecordRate();
    if (datalist && datalist.length > 0) {
      list = list.concat(datalist);
    }
    this.items = [];
    this.shownLineData = [];
    this.lineData = list.map((v: any) => {
      this.items.push(v.job_group_name);
      return { ...v, category: this.DICT_VALUE('DICT_SCHEDULE_JOB_GROUP', v.job_group_name) };
    });
    this.changeShownLineData();
  }

  switchActive(k: number) {
    this.showCard[k].active = !this.showCard[k].active;
    this.items = [];
    this.showCard.forEach(v => {
      if (v.active) this.items.push(v.title);
    });
    this.changeShownLineData();
  }

  changeShownLineData() {
    let list: any = [];
    this.lineData.forEach((v: any) => {
      if (this.items.find(value => value === v.job_group_name)) {
        list.push(v);
      }
    });
    this.shownLineData = list;
  }
}
